import { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { GiftCardsService } from '../../services/giftCards';
import { IReferralInvite } from '../../services/giftCards/types';
import history from '../../utils/history';
import { NAVIGATION } from '../App/constants';
import { storeGiftCardCode } from '../GiftCard/utils';

export const REFERRAL_KEY = 'tictactrip:referral';

/**
 * @description The referral the visitor came with, while its code still waits for the checkout.
 * @returns {IReferralInvite | null}
 */
export const getStoredReferral = (): IReferralInvite | null => {
  try {
    return JSON.parse(window.localStorage.getItem(REFERRAL_KEY) ?? 'null');
  } catch {
    return null;
  }
};

/**
 * @description /p/<CODE>, the link a customer shares: the code waits for the checkout, the friend lands on the home
 * page with a banner naming who sent it. An unknown code just lands on the home page.
 * @param {RouteComponentProps<{ code: string }>} props
 * @returns {null}
 */
const Referral = ({ match }: RouteComponentProps<{ code: string }>) => {
  useEffect(() => {
    GiftCardsService.getReferral(match.params.code)
      .then((referral) => {
        storeGiftCardCode(referral.code);
        try {
          window.localStorage.setItem(REFERRAL_KEY, JSON.stringify(referral));
        } catch {
          // The code still waits for the checkout: only the banner is missing
        }
      })
      .catch(() => null)
      .finally(() => history.replace(NAVIGATION.HOME));
  }, [match.params.code]);

  return null;
};

export default Referral;
